import type { LandingNotification } from '../types/landing'

/**
 * The header logo is payload-driven, not type-driven: any notification whose
 * data carries a team_uid renders that team's logo above the title. Returns
 * undefined when there is nothing usable to fetch, in which case the view
 * renders no logo at all.
 */
export const resolveHeaderTeamUid = (
  notification?: LandingNotification
): string | undefined => {
  const teamUid = notification?.data?.team_uid

  if (typeof teamUid !== 'string') {
    return undefined
  }

  const trimmed = teamUid.trim()

  return trimmed.length > 0 ? trimmed : undefined
}
